export default __webpack_public_path__ + "static/N0080-89233e234017a4066afba0736481a371.png";